import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetSoilUsesInputDto, SoilUseCreateDto, SoilUseDto, SoilUseExcelDownloadDto, SoilUseUpdateDto } from '../dtos/soil-use/models';

@Injectable({
  providedIn: 'root',
})
export class SoilUseService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: SoilUseCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SoilUseDto>({
      method: 'POST',
      url: '/api/planning/soilUses',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/soilUses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/soilUses',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SoilUseDto>({
      method: 'GET',
      url: `/api/planning/soilUses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/soilUses/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetSoilUsesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<SoilUseDto>>({
      method: 'GET',
      url: '/api/planning/soilUses',
      params: { name: input.name, soilUseGroupId: input.soilUseGroupId, soilUseGroupName: input.soilUseGroupName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: SoilUseExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/soilUses/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, soilUseGroupId: input.soilUseGroupId, soilUseGroupName: input.soilUseGroupName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SoilUseDto[]>({
      method: 'GET',
      url: '/api/planning/soilUses/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: SoilUseUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SoilUseDto>({
      method: 'PUT',
      url: `/api/planning/soilUses/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}